import React from 'react';
import './GlassButton.scss';
import { Link } from 'react-router-dom';

export type GlassTone = 'green' | 'dark' | 'plain' | 'back';

interface GlassButtonProps {
    children: React.ReactNode;
    tone: GlassTone;
    className?: string;
    to?: string;
    href?: string;
    onClick?: () => void;
    disabled?: boolean;
    'aria-describedby'?: string;
}
function GlassButton({
    children,
    tone,
    className,
    to,
    href,
    onClick,
    disabled,
    'aria-describedby': ariaDescribedby,
}: GlassButtonProps): React.ReactElement {
    const classes = [
        'rd-btn',
        `rd-btn--${tone}`,
        disabled ? 'rd-btn--disabled' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    if (disabled) {
        return (
            <button
                type="button"
                className={classes}
                aria-disabled="true"
                aria-describedby={ariaDescribedby}
                onClick={event => event.preventDefault()}
            >
                <span className="rd-btn__bg" aria-hidden="true" />
                <span className="rd-btn__content">{children}</span>
            </button>
        );
    }

    if (to) {
        return (
            <Link
                className={classes}
                to={to}
                aria-describedby={ariaDescribedby}
            >
                {children}
            </Link>
        );
    }
    if (href) {
        return (
            <a
                className={classes}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-describedby={ariaDescribedby}
            >
                {children}
            </a>
        );
    }
    return (
        <button
            type="button"
            className={classes}
            onClick={onClick}
            aria-describedby={ariaDescribedby}
        >
            {children}
        </button>
    );
}

GlassButton.defaultProps = {
    className: undefined,
    to: undefined,
    href: undefined,
    onClick: undefined,
    disabled: false,
    'aria-describedby': undefined,
};

export default GlassButton;
